/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{box-shadow:0 2px 8px rgba(5,74,136,.15);padding:16px;min-height:100px}.header[_ngcontent-%COMP%]{display:flex;color:#46a5f8;font-size:14px;font-weight:600}.icon[_ngcontent-%COMP%]{margin-right:10px}.icon-circle[_ngcontent-%COMP%]{fill:#eaf4fd}.text[_ngcontent-%COMP%]{margin-top:10px;color:#78787a}"];
export { styles as styles };
